import * as React from 'react';
import {Button, Dropdown, Flag, Icon, Menu, Responsive} from 'semantic-ui-react';
import Popout from 'react-popout';
import AppRoute from '../../AppRoute';
import ExportContextHolder from "../../../../lib/ExportContextHolder";
import PrintableTable from "../PrintableTable/PrintableTable";
import AppContainer from "../../containers/AppContainer/AppContainer";
import authService from "../../services/AuthService";
import i18n from "../../../../locale/i18n";
import './AppHeader.css';
import fileDownload from 'js-file-download';

import toCsvString from 'csv-stringify/lib/es5'; // lib/es5 to support older browsers


const translator = i18n.t.bind(i18n);
const logo = require('../../logo.svg');

interface IAppHeaderProps {
    onLogout: Function;
    routes: AppRoute[];
    content: any,
    sidebar: any
}

interface IAppHeaderState {
    printState: boolean,
    exporting: boolean;
}

class AppHeader extends React.Component<IAppHeaderProps, IAppHeaderState> {

    public static instance: AppHeader;
    private readonly popupRef: React.Ref<any>;

    constructor(props: IAppHeaderProps) {
        super(props);

        AppHeader.instance = this;

        this.state = {
            printState: false,
            exporting: false
        };

        this.popupRef = React.createRef();

        this.onChangeLanguage = this.onChangeLanguage.bind(this);
        this.closePrintWindow = this.closePrintWindow.bind(this);
        this.exportCsv = this.exportCsv.bind(this);

        ExportContextHolder.reloadHeaderFunc = this.forceUpdate.bind(this);
    }

    public componentDidMount() {
    }

    public toggleSidebar() {
        this.props.sidebar.current.toggle();
    }

    public onChangeLanguage(language: string) {
        i18n.changeLanguage(language);
        AppContainer.instance.forceUpdate();
    }

    public exportPrint() {

        if (this.state.printState) {
            return;
        }

        this.setState({
            "printState": true,
        });
    }

    public exportCsv() {
        if(this.state.exporting) {
            return;
        }
        this.setState({
            exporting: true
        }, () => {

            if (ExportContextHolder.customCSVRenderer) {
                const data = ExportContextHolder.customCSVRenderer();
                toCsvString(data,
                    {
                        delimiter: ';',
                        cast: {
                            string: function(value, context){
                                return `="${value}"` // TODO this works in excel but is not actually good for using CSV in other contexts
                            },
                            number: function (value, context) {
                                return value.toString().replace(".", ",")
                            }
                        }
                    }, (err, output) => {
                        if(err || !output) {
                            this.setState({exporting: false});
                            return;
                        }
                        const BOM = "\uFEFF";
                        fileDownload(BOM + output, 'export.csv', 'text/csv;charset=utf-8');
                        this.setState({exporting: false});
                    });

                return;
            }


            ExportContextHolder.exportPrintV2(
                data => {
                    toCsvString(data,
                        {
                        delimiter: ';',
                        cast: {
                            string: function(value, context){
                                return `="${value}"` // TODO this works in excel but is not actually good for using CSV in other contexts
                            }
                        }
                    }, (err, output) => {
                        if(err || !output) {
                            this.setState({exporting: false});
                            return;
                        }
                        const BOM = "\uFEFF";
                        fileDownload(BOM + output, 'export.csv', 'text/csv;charset=utf-8');
                        this.setState({exporting: false});
                    });
                },
                progress => {

                },
                error => {
                    this.setState({exporting: false});
                }
            )
        });
    }

    public closePrintWindow() {
        this.setState({
            printState: false
        });
    }

    private renderDesktopItems() {
        return (
            <>
                <Menu.Item className="menu-item-logo" header={true}>
                    <Button className={"menu-button"} onClick={this.toggleSidebar.bind(this)} icon={"bars"}>
                    </Button>
                    <img src={logo} className="App-logo" alt="logo"/>
                </Menu.Item>

                <Responsive minWidth={768} as={Menu.Item} position="right">
                    <Button className={"menu-button"} content={translator("Common.Print")} icon={"print"} onClick={this.exportPrint.bind(this)}  disabled={ExportContextHolder.enabled !== true}></Button>
                    <Button loading={this.state.exporting} className={"menu-button"} content={translator("Common.CSV")} icon={"file excel"} onClick={this.exportCsv} disabled={ExportContextHolder.enabled !== true}></Button>
                </Responsive>
                <Responsive minWidth={768} as={Menu.Item} position="right">
                    <Flag name={"de"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("de")}}/>
                    <Flag name={"gb"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("en")}}/>
                    <Flag name={"nl"} className={"languageChangeFlag"} onClick={()=> {this.onChangeLanguage("nl")}}/>
                    {authService.loggedIn ? (
                        <Dropdown
                            trigger={<span><Icon name={"user"}/> <strong>{authService.principal.name} <Icon name={"caret down"}/></strong></span>}
                            icon={null}
                            pointing="top right">
                            <Dropdown.Menu>
                                <Dropdown.Item text={translator("Profile.Profile")} icon="user" as={"a"} href="#/profile"/>
                                <Dropdown.Divider />
                                <Dropdown.Item text={translator("Menu.Logout")} icon="sign out" onClick={() => this.props.onLogout()}/>
                            </Dropdown.Menu>
                        </Dropdown>
                    ) : (
                        <Button primary onClick={() => authService.redirectToLoginForm()}>{translator("Auth.Login")}</Button>
                    )}
                </Responsive>
            </>
        )
    }

    private renderPrintPopup() {
        if (this.state.printState === false) {
            return (<></>);
        }

        return (
            <Popout title={translator("Common.Print")} ref={this.popupRef} name={"Print"}
                    onClosing={this.closePrintWindow}
                    options={{width: '800px', height: '500px', toolbar: false, location: false, menubar: false}}>
                <PrintableTable reset={this.closePrintWindow}/>
            </Popout>
        );
    }

    public render() {
        return (
            <>
                <Menu borderless={true} fluid={true} compact={true} size="small" className="app-header-menu">
                    {this.renderDesktopItems()}
                </Menu>
                {this.renderPrintPopup()}
            </>
        );
    }
}

export default AppHeader;